export default __webpack_public_path__ + "static/media/encourage.df61b20e.mp3";